import styles from './index.module.scss';
import NinjazLogo from "@/app/_components/Shared/NinjazLogo";

export default function Complete({data, score}) {
    let color = '#E23A45';
    let message = "You really need help! Consider expert assistance to guide you through the process.";
    if (score >= 4.5) {
        color = '#31A414';
        message = "Great! Your risk is low, and you're ready to go.";
    } else if (score >= 3) {
        color = '#E97B16';
        message = "You’re on the right track, but there's room for improvement. Let’s make sure everything is in order.";
    }

    return (
        <div className={styles.container}>
            <h2>Risk Score Result</h2>
            <NinjazLogo fill={color} />
            <p className={styles.score} style={{color}}>{score}</p>
            <p>{message}</p>
        </div>
    )
}